import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip0_22906_191409)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5 4.5C4.4 4.5 4 4.9 4 5.5V11.5C4 12.1 3.6 12.5 3 12.5C2.4 12.5 2 12.1 2 11.5V5.5C2 3.8 3.3 2.5 5 2.5H10H14H19C20.7 2.5 22 3.8 22 5.5V11.5C22 12.1 21.6 12.5 21 12.5C20.4 12.5 20 12.1 20 11.5V5.5C20 4.9 19.6 4.5 19 4.5H15V7.5C15 8.1 14.6 8.5 14 8.5H10C9.4 8.5 9 8.1 9 7.5V4.5H5ZM13 6.5H11V4.5H13V6.5ZM3 20.5C3 21.1 3.4 21.5 4 21.5H6C7.7 21.5 9 20.2 9 18.5V16.5C9 14.8 7.7 13.5 6 13.5H4C3.4 13.5 3 13.9 3 14.5V20.5ZM6 19.5H5V15.5H6C6.6 15.5 7 15.9 7 16.5V18.5C7 19.1 6.6 19.5 6 19.5ZM14 21.5H11C10.4 21.5 10 21.1 10 20.5V14.5C10 13.9 10.4 13.5 11 13.5H14C14.6 13.5 15 13.9 15 14.5C15 15.1 14.6 15.5 14 15.5H12V16.5H14C14.6 16.5 15 16.9 15 17.5C15 18.1 14.6 18.5 14 18.5H12V19.5H14C14.6 19.5 15 19.9 15 20.5C15 21.1 14.6 21.5 14 21.5ZM19.1 20.9C19.3 21.3 19.6 21.5 20 21.5C20.2 21.5 20.3 21.5 20.5 21.4C20.9 21.2 21.1 20.6 20.9 20.1L19.6 17.5L20.9 14.8C21 14.7 21 14.6 21 14.4C21 14 20.8 13.7 20.4 13.5C19.9 13.2 19.3 13.4 19.1 13.9L18.5 15.1L17.9 13.9C17.7 13.5 17.1 13.3 16.6 13.5C16.2 13.7 16 14.3 16.2 14.8L17.5 17.4L16.2 20C15.9 20.5 16.1 21.1 16.6 21.3C17.1 21.6 17.7 21.4 17.9 20.9L18.5 19.7L19.1 20.9Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("clipPath", { id: "clip0_22906_191409" }, [
    /*#__PURE__*/_createVNode("rect", {
      width: "20",
      height: "20",
      fill: "white",
      transform: "translate(0 0.5)"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}